
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import './BookingListItem.scss'
import { Booking } from '../models/Booking';
import Passenger from '../../Passenger/models/Passenger';
import { Helpers } from '../../../util/Helpers';
import { Guid } from 'guid-typescript';
import vuetifyToast from 'vuetify-toast'
import { BookingState } from '@/components/Booking/models/BookingState';
import { BookingStates } from '@/components/Booking/models/BookingStates';
import BookingEditor from '@/components/Booking/components/BookingEditor.vue';
import BookingInfoDialog from '@/components/Booking/components/BookingInfoDialog.vue';
import { RolePermission } from '@/models/Role';
import BookingPassenger from '@/components/Booking/models/BookingPassenger';

@Component({
    components: {
    }
})
export class BookingListItem extends Vue {

    @Prop({required: true})  
    bookingId: Guid;
    @Prop({required: false, default: true })  
    listView: boolean;
    @Prop({default: () => [] })  
    headers: any[];
    orderInProgress: boolean = false;
    cancelOrderInProgress: boolean = false;
    $dateHelper: any;
    $t: any;

    s: BookingStates = new BookingStates();
    get booking(): Booking {
        return this.$store.state.booking.bookings.find(t => t.id === this.bookingId);
    }
    get bookingIsAccepted(){
        return this.booking.isAccepted;
    }
    get bookingIsOrdered(){
        return this.booking.isOrdered;
    }
    get bookingIsLocked(){
        return this.booking.isLocked;
    }
    get bookingIsOrderable(){
        return this.booking.isOrderable;
    }
    get bookingOrderIsCancelable(){
        return this.booking.isOrderIsCancelable;
    }
    get bookingHasExpired(){
        return this.booking.hasExpired;
    }
    get bookingStartDateTooClose(){
        return !this.booking.hasEnoughTimeBeforeStart;
    }
    get bookingStartDatePassed(){
        return this.booking.hasStartDatePassed;
    }
    get bookingDaysUntilStart(){
        return this.booking.daysUntilStart;
    }   
    get bookingCurrentStateColor(){
        return this.booking.currentStateColor;
    }
    get bookingCurrentStateAlertClass(){
        return this.booking.currentStateAlertClass;        
    }
    
    get bookingIsSaved(){
        // TODO: Implement
        // Saved means if there's a order for it and that there's no changes after the previous order are 
        return true;
    }
   
    get bookingPassengersCount(): number {
        return this.booking.unnamedPassengersCount; // this.bookingPassengers.length;
    }

    get routeDestinationId(): number {
        return parseInt(this.$store.state.route.params.destinationId, 10);
    }

    get me() {
        return this.$store.state.user.me;
    }

    get userCanEditBookings(): boolean {
        return this.me 
            ? this.me.hasPermissions(this.routeDestinationId, [RolePermission.UpdateBookings])
            : false;
    }

    bookingHasPassenger(t, passenger){
        return t.bookingPassengers.some(tp => tp.passengerId === passenger.id);
    }

    async saveBooking(booking: Booking) {
        await this.$store.dispatch('booking/updateBooking', 
            { 
                params: { 
                    id: booking.id,
                    destinationId: booking.destinationId
                }, data: booking 
            });
    }

    get helpers(){
        return Helpers
    }

    activate(){
        this.$store.dispatch("app/setLastSelectedBookingId", this.booking.id);
    }

    onBookingEditClick(){
        // console.log("onBookingEditClick()");
        this.$root.$emit(BookingEditor.EVENT_BOOKING_EDITOR_OPEN, this.booking);
    }

    onBookingInfoClick(){
        // console.log("onBookingInfoClick()");
        this.$root.$emit(BookingInfoDialog.EVENT_BOOKING_INFO_DIALOG_OPEN, this.booking);
    }
    
    async onCancelOrderBookingClick() {
        // TODO: Send the order cancellation, don't just update the state, let the api update the state
        // TODO: Do we need a state OrderCancelled?

        this.cancelOrderInProgress = true;
        try {
            const response = await this.$store.dispatch(
                    'booking/deleteBooking', 
                    { 
                        params: {
                            destinationId: this.routeDestinationId,
                            id: this.booking.id
                        }
                    }
                );
            vuetifyToast.success(this.$i18n.translate("booking.order.canceled.notification", "Order canceled."));
        } catch (err) {
            vuetifyToast.error(
                this.$i18n.translate(
                    "booking.order.canceled.error", 
                    "Error when canceling order: {errorMessage}", 
                    { errorMessage: (err as any).message }
                )
            );
        }
        this.cancelOrderInProgress = false;
    }
    async onOrderBookingClick() {
        // this.orderInProgress = true;
        // try {
        //     const apiBooking = Booking.toApi(this.booking);
        //     apiBooking.State = BookingStates.Open.id;
        //     await this.saveBooking(apiBooking);
        //     vuetifyToast.success(this.$i18n.translate("booking.order.sent.notification", "Order sent."));
        // } catch (err) {
        //     vuetifyToast.error(
        //         this.$i18n.translate(
        //             "booking.order.sent.error", 
        //             "Error when sending order: {errorMessage}", 
        //             {errorMessage: err.message}
        //         )
        //     );
        // }

        // this.orderInProgress = false;
    }
    // onListItemClick(e: Event){
    //     if (!this.listView){
    //         this.$root.$emit(BookingEditor.EVENT_BOOKING_EDITOR_OPEN, this.booking);
    //     }
    // }
    onAddPeopleClick(){
        this.activate();
        setTimeout(() => {
            this.$router.push({
                name: 'Booking', 
                params: { 
                    bookingId: this.booking.id.toString()
                },
                query: { addpeople: "true" }
            });
        }, 500);
    }

}

export default BookingListItem;
